import React from 'react';
export function Footer() {
  return <footer className="border-t border-ballet-line bg-white px-4 py-8 text-center" data-id="element-128">
      <p className="text-sm text-ballet-muted" data-id="element-129">
        © 2026 Ballet Teacher Ready™ — All rights reserved.
      </p>
    </footer>;
}